import { api } from "@/APIRequests";
import type { PatientStrengthsResponse } from "@/core/types";

export async function getStrengths(patientId: string): Promise<PatientStrengthsResponse> {
  return api.carePlanTyped.get_patient_strengths({
    params: { showLoader: false },
    patientId,
  });
}
